module.exports = __webpack_public_path__ + "static/preview-fintechconnector-e6e07ade736aabb0daea5637e97ba5f7.png";